// Expose `this.$cookies` globally for components that used the vue-cookies plugin.
// Delegates to the js-cookie wrapper in src/libs/cookies.js.

import cookies from '../libs/cookies'

export default {
  install (app) {
    app.config.globalProperties.$cookies = cookies
  },
}
